import React, { useEffect, useRef } from 'react';
import { useDisableMapEvents } from '../hooks/useDisableMapEvents'

export default function PlumeLegend({ data = [], gas = '', unit = 'ppm', offsetRight = 10 }) {
  const ref = useRef(null);
  useDisableMapEvents(ref);

  return (
    <div
      ref={ref}
      className="map-card"
      style={{
        // right: offsetRight,
        // top: 60,
        padding: '14px 16px',
        maxWidth: 240
      }}
    >
    <div className="map-card-title">
      {gas}
    </div>
    <div className="map-card-title">
      Pollution level ({unit})
    </div>

      <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {data.map((r, idx) => (
          <div key={idx} className="map-card-row">
            <div
              style={{
                width: 16,
                height: 16,
                background: r.color,
                border: '1px solid #000',
                borderRadius: 4,
                marginRight: 8,
              }}
            />
            <span>
              {r.from.toFixed(2)} – {r.to.toFixed(2)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
